import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import "../NTFS/ntfs.scss";
import {
  SET_AZURE_SECRET,
  SET_AZURE_TENANT_ID,
  SET_CLIENT_ID,
  SET_WORKSPACE_ID,
} from "../../../redux/constants/constants";
import DynamicFormField from "../NTFS/DynamicFormField";

const MSSentinalConfiguration = ({ errorObj, setErrorObj }) => {
  const dispatch = useDispatch();

  const { workSpaceId, azureTenantId, clientId, azureSecret } = useSelector(
    (state) => state.tenantSignUpReducer
  );

  const [showWorkspace, setShowWorkspace] = useState(false);
  const [showTenant, setShowTenant] = useState(false);
  const [showClientId, setShowClientId] = useState(false);
  const [showAzureSecret, setShowAzureSecret] = useState(false);

  const toggleWorkspaceVisibility = () => {
    setShowWorkspace((prev) => !prev);
  };

  const toggleTenantVisibility = () => {
    setShowTenant((prev) => !prev);
  };

  const toggleClientIDVisibility = () => {
    setShowClientId((prev) => !prev);
  }

  const toggleSecretVisibility = () => {
    setShowAzureSecret((prev) => !prev);
  }

  const handleWorkspaceChange = (e) => {
    dispatch({
      type: SET_WORKSPACE_ID,
      payload: e.target.value,
    });
  };

  const handleTenantChange = (e) => {
    dispatch({
      type: SET_AZURE_TENANT_ID,
      payload: e.target.value,
    });
  };

  const handleClientIdChange = (e) => {
    dispatch({
      type: SET_CLIENT_ID,
      payload: e.target.value,
    });
  };

  const handleAzureSecretChange = (e) => {
    dispatch({
      type: SET_AZURE_SECRET,
      payload: e.target.value,
    });
  };

  return (
    <div className="ntfsMainContainer">
      <h2 className="ntfsHeading">Microsoft Sentinel Configuration</h2>
      <div className="ntfsS3fieldContainer">
        <DynamicFormField
          label="Workspace ID"
          value={workSpaceId || ""}
          type="password"
          placeholder="Enter Workspace ID"
          onChange={handleWorkspaceChange}
          showPassword={showWorkspace}
          togglePasswordVisibility={toggleWorkspaceVisibility}
          important={false}
        />

        <DynamicFormField
          label="Azure Tenant ID"
          value={azureTenantId || ""}
          type="password"
          placeholder="Enter Azure Tenant ID"
          onChange={handleTenantChange}
          showPassword={showTenant}
          togglePasswordVisibility={toggleTenantVisibility}
          important={false}
        />

        <DynamicFormField
          label="Client ID"
          value={clientId || ""}
          type="password"
          placeholder="Enter Client ID"
          onChange={handleClientIdChange}
          showPassword={showClientId}
          togglePasswordVisibility={toggleClientIDVisibility}
          important={false}
        />

        <DynamicFormField
          label="Client Secret"
          value={azureSecret || ""}
          type="password"
          placeholder="Enter Client Secret"
          onChange={handleAzureSecretChange}
          showPassword={showAzureSecret}
          togglePasswordVisibility={toggleSecretVisibility}
          important={false}
        />
      </div>
    </div>
  );
};

export default MSSentinalConfiguration;